import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

export default class JumpToStep extends Component {

  static defaultProps = {
    className: ''
  }

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    steps: PropTypes.array,
    which: PropTypes.string,
  }

  constructor(props) {
    super(props)
    const { steps, which } = this.props
    this.step = (steps || []).find((step) => step.key === which)
  }

  @autobind
  handleClick() {
    if (this.props.onClick) {
      this.props.onClick({
        target: {
          value: this.step.key
        }
      })
    }
  }

  render() {
    if (!this.step) {
      return (
        <span>
          No such step
          {this.props.which}
        </span>
      )
    }
    const { title } = this.step
    return (
      <a
        title={title}
        className={
          [
            'jump-to-step',
            ...(this.props.children
              ? ['block']
              : (['btn', 'btn-link'])
            ),
            this.props.className
          ].join(' ').trim()
        }
        onClick={this.handleClick}
      >
        <i className="glyphicon glyphicon-pencil" />
        {this.props.children}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/JumpToStep.js